import { render, staticRenderFns } from "./workHours.vue?vue&type=template&id=1922d75a&scoped=true"
import script from "./workHours.vue?vue&type=script&lang=js"
export * from "./workHours.vue?vue&type=script&lang=js"
import style0 from "./workHours.vue?vue&type=style&index=0&id=1922d75a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1922d75a",
  null
  
)

export default component.exports